export const numeroRequerimiento = (state) => {
  return state.numeroRequerimiento
}

export const result = (state) => {
  return state.result
}

export const enviadas = (state) => {
  return state.enviadas
}

export const registros = (state) => {
  return state.registros
}

export const comprobacion = (state) => {
  return state.comprobacion
}

export const resultadoExportacion = (state) => {
  return state.resultadoExportacion
}

export const loaded = (state) => {
  return state.loaded
}